import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setHighlightedStop as setHighlightedStopAction } from '#/transit-tracker/slice';

export default () => {
  const dispatch = useDispatch();
  const { highlightedStop } = useSelector(s => s.transitTracker);
  const setHighlightedStop = useCallback(
    stop => {
      dispatch(setHighlightedStopAction(stop));
    },
    [dispatch]
  );

  return {
    highlightedStop,
    setHighlightedStop,
  };
};
